<template>
  <section>
    <validation-observer ref="formValidator">
      <page-header
        :actions="[
          {
            component: 'ActionButton',
            text: 'No Disponible para Vincular',
            icon: 'fas fa-times-circle color-primary-1',
            variant: 'outline-success',
            visible: this.canInactivate,
            click: () => (showDisciplineTypeComponent = true),
          },
          {
            component: 'ActionButton',
            text: 'Inactivar',
            icon: 'fas fa-user-slash',
            variant: 'outline-success',
            click: this.onInactivate,
            visible: this.canInactivate,
          },
          {
            component: 'ActionButton',
            text: 'Re-Activar',
            variant: 'outline-success',
            icon: 'fas fa-user-alt',
            click: this.onActivate,
            visible: this.canActivate,
          },
        ]"
        :on-return="() => $router.go(-1)"
        :page="page"
      />

      <selection-component
        v-if="showDisciplineTypeComponent"
        class="mb-3"
        :error-msgs="{}"
        icon="fas fa-folder-tree"
        :label="{
          main: 'Disciplina(s) disponible(s) para Vincular',
          selected: 'Disciplinas Removidas',
          dd: 'Disciplina(s):',
        }"
        :list="listDisciplineTypes"
        :save="saveDisciplineType"
        @onClose="onClosedDisciplineType()"
      />

      <board class="mb-4" :details="board" />

      <section-title content="Información General" :has-line="true" />

      <GeneralInformation
        v-model="model"
        :initial-npi="initialNpi"
        :initial-npi-depr="initialNpiDepr"
        :is-medicaid-documentation-workflow-enabled="
          isMedicaidDocumentationWorkflowEnabled
        "
        :show-edit="canEditGeneralInformation"
        :show-school-section="showSchoolSection"
        @save-npi="saveNpi"
        @save-npi-depr="saveDeprNpi"
      >
        <span style="margin-top: 30px;">
          <action-button
            :disabled="!hasGeneralInfoPendingChanges"
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger danger"
            @click="handleCancelGeneralInfo"
          >
            Cancelar
          </action-button>
          <action-button
            :disabled="!hasGeneralInfoPendingChanges"
            i="fas fa-save"
            variant="success ml-4"
            @click="handleSaveGeneralInfo"
          >
            Guardar
          </action-button>
        </span>
      </GeneralInformation>

      <section-title content="Información Demográfica" :has-line="true" />

      <div class="row mb-4 pl-3">
        <div class="col-sm">
          <custom-input-display
            v-model="model.locationTypeName"
            label=" Tipo de Lugar:"
          />
        </div>

        <!-- Oficina del Proveedor -->
        <div
          v-if="
            showProviderOfficeSection || showHogarSection || isAssistedTherapy
          "
          class="col-sm"
        >
          <custom-input-display v-model="model.locationName" label="Nombre:" />
        </div>

        <!-- Center -->
        <div v-if="showCSEESection" class="col-sm">
          <custom-input-display v-model="model.centerName" label="Centro:" />
        </div>
        <div
          v-if="
            showCSEESection || showProviderOfficeSection || isAssistedTherapy
          "
          class="col-sm"
        >
          <custom-input-display
            v-model="model.municipalityName"
            label="Municipio:"
          />
        </div>

        <!-- CAAT -->
        <div v-if="showCAATSection" class="col-sm">
          <custom-input-display v-model="model.caatName" label="Caat:" />
        </div>
        <div v-if="showCAATSection" class="col-sm">
          <custom-input-display
            v-model="model.caatMunicipalityName"
            label="Municipio:"
          />
        </div>

        <!-- Escuela -->
        <div v-if="showSchoolSection" class="col-sm">
          <custom-input-display v-model="model.regionName" label="Región:" />
        </div>
        <div v-if="showSchoolSection" class="col-sm">
          <custom-input-display
            v-model="model.districtName"
            label="Distrito:"
          />
        </div>
        <div v-if="showSchoolSection" class="col-sm">
          <custom-input-display
            v-model="model.locationSchoolName"
            label="Escuela:"
          />
        </div>
      </div>

      <div class="mb-5">
        <b-row>
          <div v-if="!showHogarSection" class="mt-3 mb-1 col-12">
            <address-information-list
              v-model="model.addresses"
              :add-enabled="userHasPermissions('servicelocation.address.add')"
              :delete-enabled="
                userHasPermissions('servicelocation.address.delete')
              "
              :edit-enabled="userHasPermissions('servicelocation.address.edit')"
              :fiscal-year-id="fiscalYearId"
              :on-deleting="onAddressDeleting"
              :on-saving="onAddressSaving"
            />
          </div>
        </b-row>

        <b-row>
          <div class="mt-3 mb-1 col-12">
            <contact-information-list
              v-model="model.contacts"
              :add-enabled="userHasPermissions('servicelocation.contact.add')"
              :civil-statuses="civilStatuses"
              :delete-enabled="
                userHasPermissions('servicelocation.contact.delete')
              "
              :edit-enabled="userHasPermissions('servicelocation.contact.edit')"
              :on-deleting="onContactDeleting"
              :on-saving="onContactSaving"
            />
          </div>
        </b-row>
      </div>

      <section-title
        v-if="model.certification && isMedicaidDocumentationWorkflowEnabled"
        content="Información de Certificación de Escuela"
        :has-line="true"
      />

      <div
        v-if="model.certification && isMedicaidDocumentationWorkflowEnabled"
        class="row p-4 my-3 justify-content-start bg-light align-items-center rounded"
      >
        <div class="col-3 d-flex flex-column">
          <label class="text-muted">Fecha de Certificación:</label>
          <span class="font-16 color-black ">
            {{ model.certification.date | date }}
          </span>
        </div>
        <div class="col-3 d-flex flex-column">
          <label class="text-muted">Fecha de Vigencia:</label>
          <span class="font-16 color-black ">
            {{ model.certification.expirationDate | date }}
          </span>
        </div>
        <div class="col-3 d-flex flex-column">
          <label class="text-muted">Documento:</label>
          <span class="font-16 color-black ">
            {{ model.certification.documentName }}
          </span>
        </div>
        <div class="col-3 d-flex flex-column align-items-end">
          <action-button
            i="fas fa-file-download"
            variant="success"
            @click="onDownloadHandler(model.certification.documentId)"
          />
        </div>
      </div>
    </validation-observer>
  </section>
</template>

<script>
import { PageHeader } from '@/shared/components/PageHeader/index';
import SectionTitle from '@/shared/components/SectionTitle';
import AddressInformationList from '@/views/provider/serviceLocation/components/AddressInformationList';
import ContactInformationList from '@/views/provider/serviceLocation/components/ContactInformationList';
import locationTypes from '@/utils/constants/locationTypes.js';
import mixWait from '@/mixins/vue-loading.js';
import mixAlert from '@/mixins/alert.mixin.js';
import CustomInputDisplay from '@/components/common/form/CustomInputDisplay';
import GeneralInformation from './GeneralInformation.vue';
import ActionButton from 'ActionButton';
import { getSysparameterByNames as _getSysparameterByNames } from '@/modules/shared/sysparameter.api';
import _generalApi from '@/modules/app/api';
import {
  updateGeneralInfo,
  getlocationservicedetail,
  getlocationservicecompany,
  insertServiceLocationAddress as _insertAddress,
  deleteServiceLocationAddress as _deleteAddress,
  updateServiceLocationAddress as _updateAddress,
  insertServiceLocationContact as _insertContact,
  deleteServiceLocationContact as _deleteContact,
  updateServiceLocationContact as _updateContact,
  updateExcludedDisciplineTypes,
  getExcludedDisciplineTypes,
  activate as _activate,
  getCivilStatuses,
  getTherapyRooms,
} from '@/modules/provider/api.js';

export default {
  name: 'EditServiceLocation',
  components: {
    PageHeader,
    SectionTitle,
    ActionButton,
    AddressInformationList,
    ContactInformationList,
    CustomInputDisplay,
    GeneralInformation,
  },
  mixins: [mixAlert, mixWait],
  data() {
    return {
      saloons: [],
      civilStatuses: [],
      page: {
        title: 'Lugares de Servicio',
        icon: 'fas fa-user-tie',
        routes: ['Proveedor', 'Lugares de Servicio'],
      },
      boardData: {
        year: '',
        company: '',
        patronal: '',
        provider: '',
      },
      fiscalYearId: null,
      addresses: [],
      contacts: [],
      clearContactObject: {},
      clearAddressObject: {},
      locationType: null,
      center: null,
      caat: null,
      caatMunicipality: null,
      municipality: null,
      region: null,
      district: null,
      school: null,
      addressMunicipality: null,
      initialNpi: null,
      initialNpiDepr: null,
      model: {
        locationSchoolNationalIdentifier: null,
        locationFiscalYearId: null,
        fiscalYearId: null,
        locationId: null,
        locationName: null,
        locationSchoolId: null,
        locationSchoolName: null,
        centerId: null,
        isActive: false,
        centerName: null,
        locationTelephoneNo: null,
        locationTelephoneFaxNo: null,
        locationTypeId: null,
        locationTypeName: null,
        locationWebsiteUrl: null,
        schoolTypeId: null,
        schoolTypeName: null,
        caatId: null,
        caatName: null,
        caatMunicipalityId: null,
        caatMunicipalityName: null,
        locationMunicipalities: [],
        companyId: null,
        regionId: null,
        regionName: null,
        districtId: null,
        districtName: null,
        municipalityId: null,
        municipalityName: null,
        addresses: [],
        contacts: [],
        certification: null,
      },
      //TODO: traer mensajes de backend
      validationMessages: {
        required: 'Campo Requerido',
        select: 'Favor Seleccione',
        invalidForm: 'Favor de completar la información solicitada.',
        successSave: '',
        invalidValue: 'Valor inválido.',
      },
      currentYearId: null,
      companyId: null,
      locationFiscalYearId: null,
      locationTypesConstants: locationTypes,
      locationTypes: [],
      municipalities: [],
      regions: [],
      districts: [],
      schools: [],
      centers: [],
      centerMunicipalities: [],
      caatCenters: [],
      caatMunicipalities: [],
      homeMunicipalities: [],
      selectedHomeMunicipalities: [],
      listDisciplineTypes: [],
      showDisciplineTypeComponent: false,
      isServiceRequestCompany: false,
      wrapperSelection: {
        header: {
          icon: 'fas fa-map-marker-alt',
          title: 'Municipios',
        },
        openMsg: 'Presione aquí para añadir municipio',
        insideIcon: { class: 'fas fa-plus', text: 'Añadir Municipio' },
        listSelected: [],
        model: [],
        containerSelection: {
          selectionLabel: '',
          placeholderSelector: 'Escriba aquí para buscar un municipio...',
        },
      },
      originalGeneralInfo: {
        locationTelephoneNo: '',
        locationTelephoneFaxNo: '',
        locationWebsiteUrl: '',
        nationalIdentifier: '',
        locationSchoolNationalIdentifier: '',
      },
      isMedicaidDocumentationWorkflowEnabled: false,
    };
  },
  computed: {
    board() {
      return [
        [
          {
            label: 'Año Fiscal:',
            icon: 'fas fa-ballot-check',
            data: this.boardData.year,
          },
          {
            label: 'Nombre de la Compañía:',
            icon: 'fas fa-address-book',
            data: this.boardData.company,
            cols: 'col-sm-6',
          },
          {
            label: 'Número Patronal:',
            icon: 'fas fa-ballot-check',
            data: this.boardData.patronal,
          },
          {
            label: 'Tipo Proveedor:',
            icon: 'fas fa-address-book',
            data: this.boardData.provider,
          },
        ],
      ];
    },
    isAssistedTherapy() {
      return (
        this.model.locationTypeId ==
        this.locationTypesConstants.CiberterapiaAsistida
      );
    },
    showProviderOfficeSection() {
      return (
        this.model.locationTypeId ==
        this.locationTypesConstants.OfficinaProveedor
      );
    },
    showHogarSection() {
      return this.model.locationTypeId == this.locationTypesConstants.Hogar;
    },
    showCAATSection() {
      return this.model.locationTypeId == this.locationTypesConstants.CAAT;
    },
    showCSEESection() {
      return this.model.locationTypeId == this.locationTypesConstants.CSEE;
    },
    showSchoolSection() {
      return this.model.locationTypeId == this.locationTypesConstants.Escuela;
    },
    showDemographicInfoSection() {
      return this.model.locationTypeId != this.locationTypesConstants.Hogar;
    },
    canActivate() {
      return !this.model.isActive;
    },
    canInactivate() {
      return this.model.isActive;
    },
    currentGeneralInfo() {
      const payload = {
        locationTelephoneNo: this.model.locationTelephoneNo ?? '',
        locationTelephoneFaxNo: this.model.locationTelephoneFaxNo ?? '',
        locationWebsiteUrl: this.model.locationWebsiteUrl ?? '',
        nationalIdentifier: this.model.nationalIdentifier ?? '',
        locationSchoolNationalIdentifier:
          this.model.locationSchoolNationalIdentifier ?? '',
      };

      return payload;
    },
    hasGeneralInfoPendingChanges() {
      return (
        JSON.stringify(this.removeSpaces(this.currentGeneralInfo)) !==
        JSON.stringify(this.removeSpaces(this.originalGeneralInfo))
      );
    },
    canEditGeneralInformation() {
      return this.userHasPermissions(
        'provider.servicelocation.generalinformation.update'
      );
    },
  },
  async mounted() {
    await this.getParams();
    this.ShowWait();
    this.locationFiscalYearId = this.$route.params.locationFiscalYearId;
    await getlocationservicedetail({
      locationFiscalYearId: this.locationFiscalYearId,
    }).then((res) => {
      this.model = res;
      this.isServiceRequestCompany = res.isServiceRequestCompany;
      this.currentYearId = res.fiscalYearId;
      this.fiscalYearId = res.fiscalYearId;
      this.companyId = res.companyId;
      this.initialNpi = res.nationalIdentifier;
      this.initialNpiDepr = res.locationSchoolNationalIdentifier;

      this.setOriginalGeneralInfo(this.model);
    });

    getlocationservicecompany({
      fiscalYearId: this.currentYearId,
      companyId: this.companyId,
    }).then((res) => {
      this.boardData.year = res.fiscalYear;
      this.boardData.company = res.companyName;
      this.boardData.patronal = res.socialSecurityNo;
      this.boardData.provider = res.companyTypeName;
    });

    await this.fetchTherapyRooms();

    getExcludedDisciplineTypes(this.$route.params.locationFiscalYearId).then(
      ({ data }) => {
        let availables = data.availableDisciplineTypes.map((item) => ({
          id: item.id,
          name: item.name,
          selected: false,
        }));

        let selected = data.selectedDisciplineTypes.map((item) => ({
          id: item.id,
          name: item.name,
          selected: true,
        }));

        this.listDisciplineTypes = availables.concat(selected);
      }
    );

    this.civilStatuses = (await getCivilStatuses()).data;

    this.HideWait();
  },
  methods: {
    async onDownloadHandler(fileId) {
      if (!fileId) return;

      try {
        await _generalApi.downloadDocumentByAttachmentId(fileId);
      } catch (e) {
        this.ShowToast &&
          this.ShowToast(
            'Error',
            'No se pudo descargar el documento. Intente nuevamente.',
            'error'
          );
      }
    },
    async fetchTherapyRooms() {
      try {
        const response = await getTherapyRooms(this.model.companyId);
        this.saloons = response.data;
      } catch (error) {
        this.showAlert(
          'Error',
          'No se pudieron cargar los salones de terapia.',
          'error'
        );
      }
    },
    async getParams() {
      const { data } = await _getSysparameterByNames({
        parameterNames: ['MedicaidDocumentationWorkflowEnabled'],
      });

      this.isMedicaidDocumentationWorkflowEnabled =
        data?.length > 0 && data[0].staticValue?.toLowerCase() == 'true';
    },
    save() {},
    async saveNpi(value, callback) {
      await this.handleSaveGeneralInfo();
      this.initialNpi = value || '';
      if (callback) callback();
    },
    async saveDeprNpi(value, callback) {
      await this.handleSaveGeneralInfo();
      this.initialNpiDepr = value || '';
      if (callback) callback();
    },
    onClosedDisciplineType() {
      this.showDisciplineTypeComponent = false;
      getExcludedDisciplineTypes(this.locationFiscalYearId).then(({ data }) => {
        let availables = data.availableDisciplineTypes.map((item) => ({
          id: item.id,
          name: item.name,
          selected: false,
        }));

        let selected = data.selectedDisciplineTypes.map((item) => ({
          id: item.id,
          name: item.name,
          selected: true,
        }));

        this.listDisciplineTypes = availables.concat(selected);
      });
    },
    saveDisciplineType(list) {
      updateExcludedDisciplineTypes({
        locationFiscalYearId: this.locationFiscalYearId,
        disciplineTypes: list.map((item) => item.id),
      }).then(() => {
        this.ShowToast(
          'Proceso Exitoso',
          'Los datos fueron actualizados exitosamente.',
          this.toastType.Success
        );
        this.showDisciplineTypeComponent = false;
      });
    },
    async onAddressSaving(savedAddress) {
      let promise = null;

      savedAddress.municipalityId = savedAddress.municipality.id;
      savedAddress.locationId = this.model.locationId;
      savedAddress.locationFiscalYearId = this.model.locationFiscalYearId;

      savedAddress.gpsLatitude =
        savedAddress.gpsLatitude != null
          ? parseFloat(savedAddress.gpsLatitude)
          : null;
      savedAddress.gpsLongitude =
        savedAddress.gpsLongitude != null
          ? parseFloat(savedAddress.gpsLongitude)
          : null;

      if (savedAddress.addressId == null)
        promise = _insertAddress(savedAddress);
      else promise = _updateAddress(savedAddress);

      let result = false;

      await promise
        .then((response) => {
          this.ShowToast(
            'Proceso Exitoso',
            'Dirección guardada exitosamente.',
            'success'
          );

          savedAddress.addressId = response.data.addressId;

          result = true;
        })
        .catch((error) => {
          this.ShowToast('Error', error.response.data.message, 'error');
          result = false;
        });

      return result;
    },
    async onAddressDeleting(addressId) {
      let promise = null;

      promise = _deleteAddress(addressId);

      let result = false;

      await promise
        .then(() => {
          this.ShowToast(
            'Proceso Exitoso',
            'Dirección eliminada exitosamente.',
            'success'
          );
          result = true;
        })
        .catch((error) => {
          this.ShowToast('Error', error.response.data.message, 'error');
          result = false;
        });

      return result;
    },
    async onContactSaving(savedContact) {
      let promise = null;
      //Set the default locationId, the primary contact has it (There is always at least a contact)
      savedContact.locationId = this.model.locationId;
      savedContact.locationFiscalYearId = this.model.locationFiscalYearId;

      if (savedContact.id == null) promise = _insertContact(savedContact);
      else promise = _updateContact(savedContact);

      let result = false;

      await promise
        .then((response) => {
          this.ShowToast(
            'Proceso Exitoso',
            'Contacto guardado exitosamente.',
            'success'
          );

          savedContact.id = response.data.id;

          result = true;
        })
        .catch((error) => {
          this.ShowToast('Error', error.response.data.message, 'error');
          result = false;
        });

      return result;
    },
    async onContactDeleting(contactId) {
      let promise = null;
      promise = _deleteContact(contactId);

      let result = false;

      await promise
        .then(() => {
          this.ShowToast(
            'Proceso Exitoso',
            'Contacto eliminado exitosamente.',
            'success'
          );
          result = true;
        })
        .catch((error) => {
          this.ShowToast('Error', error.response.data.message, 'error');
          result = false;
        });

      return result;
    },
    async onActivate() {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea re-activar el lugar de servicio <b>${this.model.locationName}</b>?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      await _activate(this.locationFiscalYearId).then(() => {
        this.model.isActive = true;
        this.ShowToast(
          'Proceso Exitoso',
          'El lugar de servicio ha sido activado exitosamente.',
          this.toastType.Success
        );
      });
    },
    async onInactivate() {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea inactivar el lugar de servicio <b>${this.model.locationName}</b>?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      await _activate(this.locationFiscalYearId, false)
        .then(() => {
          this.model.isActive = false;
          this.ShowToast(
            'Proceso Exitoso',
            'El lugar de servicio ha sido inactivado exitosamente.',
            this.toastType.Success
          );
        })
        .catch((error) => {
          this.ShowToast('Error', error.response.data.message, 'error');
        });
    },
    removeSpaces(obj) {
      return JSON.parse(
        JSON.stringify(obj, (key, value) =>
          typeof value === 'string' ? value.replace(/\s+/g, '') : value
        )
      );
    },
    setOriginalGeneralInfo(payload) {
      this.originalGeneralInfo = {
        locationTelephoneNo: payload.locationTelephoneNo ?? '',
        locationTelephoneFaxNo: payload.locationTelephoneFaxNo ?? '',
        locationWebsiteUrl: payload.locationWebsiteUrl ?? '',
        nationalIdentifier: payload.nationalIdentifier ?? '',
        locationSchoolNationalIdentifier:
          payload.locationSchoolNationalIdentifier ?? '',
      };
    },
    async handleSaveGeneralInfo() {
      const isValid = await this.$refs.formValidator.validate();
      if (!isValid) return;

      const payload = {
        locationFiscalYearId: parseInt(this.locationFiscalYearId),
        ...this.currentGeneralInfo,
      };

      await updateGeneralInfo(payload);
      this.setOriginalGeneralInfo(payload);
      this.ShowToast(
        'Proceso Exitoso',
        'Información guardada exitosamente.',
        'success'
      );
    },
    handleCancelGeneralInfo() {
      this.model.locationTelephoneNo = this.originalGeneralInfo.locationTelephoneNo;
      this.model.locationTelephoneFaxNo = this.originalGeneralInfo.locationTelephoneFaxNo;
      this.model.locationWebsiteUrl = this.originalGeneralInfo.locationWebsiteUrl;
      this.model.nationalIdentifier = this.originalGeneralInfo.nationalIdentifier;
      this.model.locationSchoolNationalIdentifier = this.originalGeneralInfo.locationSchoolNationalIdentifier;
    },
  },
};
</script>
